const visibleClass = 'site-reveal--visible'

let observer = null
let reduceMotion = false

function canAnimate() {
  if (typeof window === 'undefined') {
    return false
  }
  reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  return !reduceMotion && 'IntersectionObserver' in window
}

function show(el) {
  el.classList.add(visibleClass)
}

function getObserver() {
  if (observer || !canAnimate()) {
    return observer
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          show(entry.target)
          observer.unobserve(entry.target)
        }
      })
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    }
  )

  return observer
}

export default {
  inserted(el, binding) {
    const value = binding.value || {}
    const type = value.type || binding.arg

    el.classList.add('site-reveal')
    if (type) {
      el.classList.add(`site-reveal--${type}`)
    }
    if (value.delay !== undefined) {
      el.style.setProperty('--site-reveal-delay', `${value.delay}ms`)
    }

    if (!canAnimate()) {
      show(el)
      return
    }

    const rect = el.getBoundingClientRect()
    if (rect.top < window.innerHeight * 1.05) {
      show(el)
    }

    getObserver().observe(el)

    window.setTimeout(() => {
      const currentRect = el.getBoundingClientRect()
      if (currentRect.top < window.innerHeight * 1.05) {
        show(el)
      }
    }, 80)
  },
  unbind(el) {
    if (observer) {
      observer.unobserve(el)
    }
  }
}
